import React, { useRef, useState } from "react";
import cx from "classnames";
import { useValidation } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import { InputErrorList } from "../input/InputErrorList";
import { RadioButton } from "./RadioButton";
import "./RadioGroup.scss";
export function RadioGroup({ alternatives, header, onChange, validators = [], forceValidation = false, value, "data-test-id": dataTestId, }) {
    const [inputName] = useState("radio_" + Math.random().toString(36).substr(2, 9));
    const containerRef = useRef(null);
    const [validity, errorMessages, validityClasses, resetValidation,] = useValidation(value, validators, forceValidation);
    useForm(inputName, validity, value, resetValidation, containerRef, errorMessages, header);
    return (React.createElement("fieldset", { className: cx("lysa-ui-radio", validityClasses), "data-test-id": dataTestId, ref: containerRef },
        React.createElement("legend", null, header),
        alternatives.map((alternative, index) => {
            let isEqual = false;
            try {
                isEqual =
                    typeof value !== "undefined" &&
                        JSON.stringify(alternative.value) === JSON.stringify(value.value);
            }
            catch (e) { }
            const isChecked = typeof value !== "undefined" &&
                alternative.text === value.text &&
                isEqual;
            return (React.createElement(RadioButton, { key: "key_" + index, alternative: alternative, checked: isChecked, onChange: onChange, inputName: inputName, "data-test-id-partial": dataTestId, index: index }));
        }),
        React.createElement(InputErrorList, { errorMessages: errorMessages })));
}
